"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[655],{

/***/ 8144:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ud": function() { return /* binding */ HomePageSeo; },
  "vG": function() { return /* binding */ NotesPageSeo; }
});

// UNUSED EXPORTS: PageSeo

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(7328);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
;// CONCATENATED MODULE: ../../packages/viteui-lib/src/utils/og-image.ts
var getOgImageUrl = function(param) {
    var title = param.title, subtitle = param.subtitle, path = param.path, ogUrl = param.ogUrl;
    var url = new URL(ogUrl);
    var queries = Object.entries({
        title: title,
        subtitle: subtitle,
        path: path
    }).filter(function(arr) {
        return !!arr[1];
    });
    for(var idx = 0; idx < queries.length; idx++){
        if (queries[idx].length === 2 && typeof queries[idx][1] === "string") {
            url.searchParams.append(queries[idx][0], queries[idx][1]);
        }
    }
    return url.href;
};
var getOgImages = function(data) {
    return [
        {
            width: 1200,
            height: 630,
            url: getOgImageUrl(data)
        }
    ];
};

// EXTERNAL MODULE: ../../node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(5351);
// EXTERNAL MODULE: ./public/shared-assets/texts/index.js + 2 modules
var texts = __webpack_require__(9597);
;// CONCATENATED MODULE: ./src/components/PageSeo.tsx





var BASE_URL = "https://ekafyi.vercel.app";
// -----
var PageSeo = function(param) {
    var path = param.path, title = param.title, appendTitle = param.appendTitle, description = param.description, ogSubtitle = param.ogSubtitle;
    if (title) {
        var canonical = path ? "".concat(BASE_URL).concat(path) : undefined;
        var fullTitle = "".concat(title).concat(appendTitle ? " | ".concat(appendTitle) : "");
        var ogData = getOgImages({
            path: path.split("/")[1],
            title: title,
            subtitle: ogSubtitle || description,
            ogUrl: "".concat(BASE_URL, "/api/social-card")
        });
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
            title: fullTitle,
            description: description,
            canonical: canonical,
            openGraph: {
                url: canonical,
                images: ogData
            }
        });
    }
    return null;
};
var NotesPageSeo = function(param) {
    var activeData = param.activeData;
    var ref, ref1;
    var NOTES_BASE_PATH = "/notes";
    if (!activeData) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(PageSeo, {
            path: NOTES_BASE_PATH,
            title: texts/* NOTES_META_TEXT.title */.ME.title,
            description: texts/* NOTES_META_TEXT.description */.ME.description,
            ogSubtitle: texts/* NOTES_META_TEXT.imageTexts.description */.ME.imageTexts.description
        });
    }
    var seoData = {
        path: "".concat(NOTES_BASE_PATH, "/").concat(activeData.slug),
        title: activeData.title,
        appendTitle: texts/* NOTES_META_TEXT.title */.ME.title,
        description: ((ref = activeData.excerpt) === null || ref === void 0 ? void 0 : ref.length) ? activeData.excerpt : undefined,
        ogSubtitle: ((ref1 = activeData.excerpt) === null || ref1 === void 0 ? void 0 : ref1.length) ? activeData.excerpt : undefined
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PageSeo, (0,_object_spread/* default */.Z)({}, seoData));
};
// -----
var HomePageSeo = function() {
    var ogData = getOgImages({
        title: texts/* SITE_META_TEXT.imageTexts.title */.C.imageTexts.title,
        subtitle: texts/* SITE_META_TEXT.imageTexts.description */.C.imageTexts.description,
        ogUrl: "".concat(BASE_URL, "/api/social-card")
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
        title: texts/* SITE_META_TEXT.title */.C.title,
        description: texts/* SITE_META_TEXT.description */.C.description,
        canonical: BASE_URL,
        openGraph: {
            url: BASE_URL,
            images: ogData
        }
    });
};


/***/ }),

/***/ 2930:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "x": function() { return /* reexport */ layouts_NoteSectionLayout; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(7328);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(6670);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../packages/viteui-lib/src/utils/datetime.ts
var datetime = __webpack_require__(5589);
// EXTERNAL MODULE: ../../packages/viteui-lib/src/components/Layouts/ClientLinkProvider.tsx
var ClientLinkProvider = __webpack_require__(4803);
;// CONCATENATED MODULE: ../../packages/viteui-lib/src/components/EntryList/EntryListItem.tsx


var EntryListItem = function(param) {
    var title = param.title, href = param.href, description = param.description, byline = param.byline, _isActive = param.isActive, isActive = _isActive === void 0 ? false : _isActive, _scrollToMe = param.scrollToMe, scrollToMe = _scrollToMe === void 0 ? false : _scrollToMe, _CustomLink = param.CustomLink, CustomLink = _CustomLink === void 0 ? null : _CustomLink;
    // Scroll list item to view if needed.
    var ref = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        if (isActive && scrollToMe && (ref === null || ref === void 0 ? void 0 : ref.current)) {
            ref.current.scrollIntoView({
                behavior: "smooth"
            });
        }
    }, [
        isActive,
        scrollToMe
    ]);
    //////
    var INNER_X_CSS = "px-2";
    var FONT_CSS = "lg:text-sm font-semibold tracking-[-0.01em] lg:tracking-[-0.006em]";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("article", {
        ref: ref,
        className: "".concat(isActive ? "bg-e-color-primaryContainer text-e-color-onPrimaryContainer" : "text-e-color-onSurface hover:bg-e-color-primary/5 focus-within:bg-e-color-primary/5", " relative rounded transition-colors duration-75 scroll-mt-16"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "".concat(INNER_X_CSS, " flex space-x-3 py-4 border-b border-e-color-outlineVariant lg:border-none"),
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col justify-center space-y-1.5",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat(FONT_CSS, " line-clamp-3"),
                        children: !!CustomLink ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink, {
                            href: href,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                "data-client-link": 1,
                                href: href,
                                children: title
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: href,
                            children: title
                        })
                    }),
                    description && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "line-clamp-2",
                        children: description
                    }),
                    byline && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "line-clamp-1 text-xs opacity-75",
                        children: byline
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ../../packages/viteui-lib/src/components/EntryList/EntryList.tsx






var EntryList = function(param) {
    var _activeSlug = param.activeSlug, activeSlug = _activeSlug === void 0 ? "" : _activeSlug, _basePath = param.basePath, basePath = _basePath === void 0 ? "" : _basePath, _data = param.data, data = _data === void 0 ? [] : _data;
    // Scroll into view only once onMount, not on subsequent rerenders.
    var calledOnce = (0,react.useRef)(false); // ?? useRef(!activeSlug)
    (0,react.useEffect)(function() {
        if (calledOnce.current) {
            return;
        }
        if (!!activeSlug) {
            calledOnce.current = true;
        }
    }, [
        activeSlug
    ]);
    //////
    var OUTER_X_CSS = "px-3";
    var CustomLink = (0,react.useContext)(ClientLinkProvider/* ClientLinkContext */.T);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: OUTER_X_CSS,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                className: "border-t-2 border-e-color-onSurface mb-2 mx-2"
            }),
            data.map(function(item) {
                var isActive = activeSlug === item.slug;
                var props = {
                    isActive: isActive,
                    scrollToMe: isActive && !calledOnce.current,
                    title: item.title,
                    href: "/".concat(basePath).concat(basePath ? "/" : "").concat(item.slug),
                    byline: item.createdAt ? (0,datetime/* formatDate */.p)(item.createdAt) : undefined,
                    CustomLink: CustomLink
                };
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(EntryListItem, (0,_object_spread/* default */.Z)({}, props), item.slug);
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/viteui-lib/src/components/Nav/Bread.tsx

var Bread = function(param) {
    var path = param.path, _outerDisplayCss = param.outerDisplayCss, outerDisplayCss = _outerDisplayCss === void 0 ? "" : _outerDisplayCss, _logoDisplayCss = param.logoDisplayCss, logoDisplayCss = _logoDisplayCss === void 0 ? "" : _logoDisplayCss;
    var mainBrandNode = /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
        href: "/",
        "aria-label": "Home",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
            className: logoDisplayCss,
            src: "/shared-assets/branding/icon-180x180.png",
            alt: "",
            width: 24,
            height: 24,
            loading: "lazy"
        })
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat(outerDisplayCss, " flex items-center gap-1"),
        children: [
            mainBrandNode,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                className: "w-6 h-6 opacity-50",
                "aria-hidden": "true",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("use", {
                    xlinkHref: "/shared-assets/images/icons.svg#slash"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                "aria-current": "true",
                children: path
            })
        ]
    });
};
/* harmony default export */ var Nav_Bread = (Bread);

// EXTERNAL MODULE: ../../packages/viteui-lib/src/components/TitleBar/TitleBarScrollObsOuter.tsx + 1 modules
var TitleBarScrollObsOuter = __webpack_require__(3404);
;// CONCATENATED MODULE: ../../packages/viteui-lib/src/components/Layouts/ListLayout.tsx







var NavDialog = /*#__PURE__*/ (0,react.lazy)(function() {
    return Promise.all(/* import() */[__webpack_require__.e(137), __webpack_require__.e(536)]).then(__webpack_require__.bind(__webpack_require__, 7536));
});
var ListLayout = /*#__PURE__*/ (0,react.forwardRef)(function(param, ref) {
    var _children = param.children, children = _children === void 0 ? null : _children, _listNode = param.listNode, listNode = _listNode === void 0 ? null : _listNode, _introNode = param.introNode, introNode = _introNode === void 0 ? null : _introNode, activeSlug = param.activeSlug, section = param.section, _data = param.data, data = _data === void 0 ? [] : _data, inView = param.inView;
    var titleProp = {
        title: (section === null || section === void 0 ? void 0 : section.title) ? section.title : ""
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                "data-site-layout-part": "list",
                className: "border-r border-e-color-outlineVariant ".concat(activeSlug ? "hidden lg:block" : ""),
                ref: ref,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleBarScrollObsOuter/* default */.Z, {
                        leadingNode: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-10 h-10 lg:hidden -ml-2",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Suspense, {
                                fallback: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: "[menu]"
                                }),
                                children: inView ? /*#__PURE__*/ (0,jsx_runtime.jsx)(NavDialog, {}) : "[unem]"
                            })
                        }),
                        trailingNode: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-10 h-10 -mr-2",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: "w-10 h-10 items-center justify-center flex",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                    width: "24",
                                    height: "24",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("use", {
                                        xlinkHref: "/shared-assets/images/icons.svg#search"
                                    })
                                })
                            })
                        }),
                        initialContentNode: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListTitle, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, titleProp), {
                                    displayCss: "hidden lg:block"
                                })),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav_Bread, {
                                    path: "notes",
                                    outerDisplayCss: "lg:hidden"
                                })
                            ]
                        }),
                        scrolledContentNode: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListTitle, (0,_object_spread/* default */.Z)({}, titleProp))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "px-5 py-4 text-2xl lg:hidden",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListTitle, (0,_object_spread/* default */.Z)({}, titleProp))
                    }),
                    introNode && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "lg:hidden",
                        children: introNode
                    }),
                    (data === null || data === void 0 ? void 0 : data.length) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(EntryList, {
                        data: data,
                        activeSlug: activeSlug,
                        basePath: (section === null || section === void 0 ? void 0 : section.path) || ""
                    }) : listNode
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                "data-site-layout-part": "detail",
                children: [
                    introNode && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "hidden lg:block",
                        children: introNode
                    }),
                    children
                ]
            })
        ]
    });
});
ListLayout.displayName = "ListLayout";
var ListTitle = function(param) {
    var title = param.title, _displayCss = param.displayCss, displayCss = _displayCss === void 0 ? "" : _displayCss;
    return title ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
        className: "font-bold ".concat(displayCss),
        children: title
    }) : null;
};

// EXTERNAL MODULE: ../../node_modules/react-intersection-observer/react-intersection-observer.m.js
var react_intersection_observer_m = __webpack_require__(7704);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(2228);
// EXTERNAL MODULE: ../../node_modules/graphql-request/dist/index.js
var dist = __webpack_require__(6647);
// EXTERNAL MODULE: ../../node_modules/swr/dist/index.mjs
var swr_dist = __webpack_require__(9857);
;// CONCATENATED MODULE: ./src/lib/client-queries.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query MyQuery {\n    continents {\n      code\n      name\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query PostsQuery {\n    allPosts {\n      title\n      slug\n      createdAt\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var API_ENDPOINT = "/api/graphql";
var CONTINENTS_API_ENDPOINT = "https://countries.trevorblades.com/graphql";
var CONTINENTS_QUERY = (0,dist.gql)(_templateObject());
var fetcher = function(query) {
    var url = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : API_ENDPOINT;
    return (0,dist.request)(url, query);
};
/**
 * Usage:
 * const { data, isLoading, isError } = useContinents();
 */ var useContinents = function() {
    var ref = useSWR([
        CONTINENTS_QUERY,
        CONTINENTS_API_ENDPOINT
    ], fetcher), data = ref.data, error = ref.error;
    if (error) console.error(error);
    return {
        data: data === null || data === void 0 ? void 0 : data.continents,
        isLoading: !error && !data,
        isError: error
    };
};
var MIN_POSTS_QUERY = (0,dist.gql)(_templateObject1());
var usePosts = function() {
    var ref = (0,swr_dist/* default */.ZP)([
        MIN_POSTS_QUERY
    ], fetcher), data = ref.data, error = ref.error;
    if (error) console.error(error);
    return {
        data: data === null || data === void 0 ? void 0 : data.allPosts,
        isLoading: !error && !data,
        isError: error
    };
};

;// CONCATENATED MODULE: ./src/components/layouts/NoteSectionLayout.tsx


 // Suspense


var NoteContext = /*#__PURE__*/ (0,react.createContext)({
    data: []
});
var NoteSectionLayout = function(param) {
    var _activeSlug = param.activeSlug, activeSlug = _activeSlug === void 0 ? "" : _activeSlug, children = param.children, _initialData = param.initialData, initialData = _initialData === void 0 ? [] : _initialData;
    (0,react.useEffect)(function() {
        console.log("Layout mounts");
    }, []); // prettier-ignore
    var ref = (0,react_intersection_observer_m/* useInView */.YD)({
        triggerOnce: true
    }), ref1 = ref.ref, inView = ref.inView;
    var ref2 = (0,react.useState)((initialData === null || initialData === void 0 ? void 0 : initialData.length) ? initialData : undefined), data = ref2[0], setData = ref2[1];
    var memoData = (0,react.useMemo)(function() {
        return {
            data: data,
            setData: setData
        };
    }, [
        data
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(NoteContext.Provider, {
        value: memoData,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListLayout, {
            ref: ref1,
            activeSlug: activeSlug,
            listNode: !(data === null || data === void 0 ? void 0 : data.length) && inView ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ClientFetcher, {}) : null,
            data: data,
            inView: inView,
            section: {
                title: "Eka\u2019s Notes",
                path: "notes"
            },
            children: children
        })
    });
};
var ClientFetcher = function() {
    (0,react.useEffect)(function() {
        console.log("Fetcher mounts");
    }, []); // prettier-ignore
    var setData = (0,react.useContext)(NoteContext).setData;
    var ref = usePosts(), posts = ref.data, isLoading = ref.isLoading, isError = ref.isError;
    // Update context data in useEffect to prevent "Cannot update a component" warning:
    // https://flaviocopes.com/react-update-while-rendering-different-component/
    (0,react.useEffect)(function() {
        if ((posts === null || posts === void 0 ? void 0 : posts.length) && typeof setData !== "undefined") {
            setData(posts);
        }
    }, [
        posts,
        isLoading,
        setData
    ]);
    if (isLoading || isError) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex items-center justify-center p-8 text-sm",
            "aria-live": "polite",
            "aria-busy": isLoading,
            role: "status",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: isLoading ? "Loading..." : "Failed fetching data. Please reload."
            })
        });
    }
    return null;
};
/* harmony default export */ var layouts_NoteSectionLayout = (NoteSectionLayout);

;// CONCATENATED MODULE: ./src/components/layouts/index.ts



/***/ }),

/***/ 3404:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ TitleBar_TitleBarScrollObsOuter; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
// EXTERNAL MODULE: ../../packages/viteui-lib/node_modules/react-intersection-observer/react-intersection-observer.modern.mjs
var react_intersection_observer_modern = __webpack_require__(4340);
;// CONCATENATED MODULE: ../../packages/viteui-lib/src/components/TitleBar/TitleBarOuter.tsx

var TitleBarOuter = function(param) {
    var _children = param.children, children = _children === void 0 ? null : _children, breakpointDisplay = param.breakpointDisplay, _bordered = param.bordered, bordered = _bordered === void 0 ? false : _bordered;
    var outerCss = "h-14 px-5 items-center gap-4 sticky top-0 inset-x-0 z-20 backdrop-blur-sm";
    var borderCss = bordered ? "shadow-md bg-e-color-surface/80" : "";
    // const displayCss = "flex";
    var displayCss = "flex";
    if (breakpointDisplay) {
        if (breakpointDisplay === "SHOW_LG_UP") {
            displayCss = "hidden lg:flex";
        } else if (breakpointDisplay === "HIDE_LG_UP") {
            displayCss = "flex lg:hidden";
        }
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat(outerCss, " ").concat(displayCss, " ").concat(borderCss),
        children: children
    });
};
/* harmony default export */ var TitleBar_TitleBarOuter = (TitleBarOuter);

;// CONCATENATED MODULE: ../../packages/viteui-lib/src/components/TitleBar/TitleBarScrollObsOuter.tsx



var TitleBarScrollObsOuter = function(param) {
    var breakpointDisplay = param.breakpointDisplay, _leadingNode = param.leadingNode, leadingNode = _leadingNode === void 0 ? null : _leadingNode, _trailingNode = param.trailingNode, trailingNode = _trailingNode === void 0 ? null : _trailingNode, _initialContentNode = param.initialContentNode, initialContentNode = _initialContentNode === void 0 ? null : _initialContentNode, _scrolledContentNode = param.scrolledContentNode, scrolledContentNode = _scrolledContentNode === void 0 ? null : _scrolledContentNode;
    var ref = (0,react_intersection_observer_modern/* useInView */.YD)({
        initialInView: true,
        rootMargin: "0px 0px 0px 0px"
    }), titleRef = ref.ref, titleInView = ref.inView;
    var displayCss = "";
    if (breakpointDisplay) {
        if (breakpointDisplay === "SHOW_LG_UP") {
            displayCss = "hidden lg:block";
        } else if (breakpointDisplay === "HIDE_LG_UP") {
            displayCss = "lg:hidden";
        }
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleBar_TitleBarOuter, {
                breakpointDisplay: breakpointDisplay,
                bordered: !titleInView,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        leadingNode,
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex-1 truncate",
                            children: titleInView ? initialContentNode : scrolledContentNode
                        }),
                        trailingNode
                    ]
                })
            }),
            scrolledContentNode && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "h-0 ".concat(displayCss),
                ref: titleRef,
                "aria-hidden": "true"
            })
        ]
    });
};
/* harmony default export */ var TitleBar_TitleBarScrollObsOuter = (TitleBarScrollObsOuter);


/***/ }),

/***/ 5589:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ formatDate; }
/* harmony export */ });
/* unused harmony export checkIfOld */
var defaultLocale = "en-GB"; // 'en', 'en-US', 'en-GB', 'id'
var defaultLocaleOptions = {
    day: "numeric",
    month: "short",
    year: "numeric"
};
/**
 * Convert a Date object to string with specified locale format.
 */ var formatDate = function(date) {
    var locale = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : defaultLocale, localeOptions = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : defaultLocaleOptions;
    if (typeof date == "string") {
        return new Date(date).toLocaleDateString(locale, localeOptions);
    } else if (typeof date == "object") {
        return date.toLocaleDateString(locale, localeOptions);
    }
    return "";
};
/**
 * Calculate if a given date is > x days from now.
 */ var checkIfOld = function(date) {
    var maxDayDiff = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1095;
    var today = new Date().getTime();
    var olderDay = new Date(date).getTime();
    var diff = today - olderDay;
    var dayDiff = diff / 24 / 60 / 60 / 1000;
    return dayDiff > maxDayDiff;
};


/***/ })

}]);